import React from 'react';
import AvatarLight from '../assets/img/avatar1.png';
import AvatarDark from '../assets/img/avatar2.png';
import { getBadgeIcon } from '../utilites/getBadgeIcon';

export default function UserAvatar({ avatar, alt, badge, style, className, ...props }) {
	const isDarkTheme =
		document?.documentElement?.getAttribute('data-bs-theme') === 'dark' || false;

	const avatarSize = style?.width ? parseInt(style.width) : 60; 
	const badgeSize = avatarSize / 2.5; 

	const badgePositionOffset = avatarSize * 0.1;

	return (
		<div
			style={{
				position: 'relative',
				display: 'inline-block',
			}}
		>
			<img
				src={
					avatar && avatar.length > 0 && avatar[0]?.path
						? avatar[0].path
						: isDarkTheme
						? AvatarDark
						: AvatarLight
				}
				alt={alt || 'User Avatar'}
				className={className}
				style={{
					...style, 
					borderRadius: '50%', 
					objectFit: 'cover',
				}}
				{...props} 
			/>

			{badge && (
				<div
					style={{
						position: 'absolute',
						bottom: `${badgePositionOffset}px`, 
						right: `${badgePositionOffset}px`,
						transform: 'translate(25%, 25%)',
					}}
				>
					{getBadgeIcon(badge, badgeSize)} 
				</div>
			)}
		</div>
	);
}